module.exports = __webpack_public_path__ + "static/media/lv_desk_s.5de5f02d.png";